<template>
          <Tables ref="tableGrid"
              :columns="columns"
              style="font-family:'Segoe UI'"
              :showSearch="false"
              :showPrint="false"
              :showDownload="false"
              :showFullscreen="false"
              v-on:Load="onLoad">
              <tr v-for="data in dataUnidade" v-bind:key="data.id">
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.nome" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.cidade.nome"/>
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.cidade.estado.sigla" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="'12 Opções'" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.dataAcaoFormatada" />
              </tr>
          </Tables>
</template>

<script>
import tablePrice from './tablePrice'
export default tablePrice

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/pricetablemanagement/components/tablePrice/tablePrice.vue